import angular from 'angular';
import { authRunner, globalRunner } from '../runners';

const module = 'app.runners';
const requires = [];

angular.module(module, requires);
angular.module(module).registerComponents({ globalRunner, authRunner }, 'run');
